// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"L2-z"};